import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Map, Globe2 } from 'lucide-react';
export function GlobalArchitecture() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-surface-muted rounded-3xl my-12" data-id="element-123">
      <div className="text-center mb-16" data-id="element-124">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-125">
          Global Architecture
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-126">
          A framework for capability, resilience, and governance
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-16" data-id="element-127">
        {/* Municipal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col" data-id="element-128">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-129">
            <MapPin size={20} className="text-navy-light" data-id="element-130" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-131">
              Municipal
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-132">
            Local capability gaps, youth opportunity pipelines, community
            resilience, and civic engagement metrics.
          </p>
        </motion.div>

        {/* Regional */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="flex flex-col" data-id="element-133">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-134">
            <Map size={20} className="text-teal" data-id="element-135" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-136">
              Regional / Provincial
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-137">
            Education reform, workforce planning, leadership development, and
            structural resilience strategy.
          </p>
        </motion.div>

        {/* National */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-col" data-id="element-138">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-139">
            <Globe2 size={20} className="text-navy" data-id="element-140" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-141">
              National
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-142">
            Civil-service modernization, ministry-level planning, executive
            readiness, and national capability mapping.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="text-center" data-id="element-143">
        <p className="text-lg font-medium text-navy bg-white inline-block px-8 py-4 rounded-lg shadow-sm border border-line" data-id="element-144">
          At scale, NCJI becomes a strategic intelligence layer for human
          development and institutional performance.
        </p>
      </motion.div>
    </section>;
}